import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { MediaStateInfo } from '../../types/generated/MediaStateInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetMediaStateQueryVariables = Types.Exact<{
  mediaStateId: Types.Scalars['ID']['input'];
}>;


export type GetMediaStateQuery = { __typename?: 'Query', getMediaState: Array<{ __typename?: 'MediaState', id?: string | null, currentCaptionIndex?: number | null, currentHlsManifestUrl?: string | null, currentTime?: number | null, currentTimeLastUpdated?: number | null, duration?: number | null, fps?: number | null, frames?: number | null, elementDuration?: number | null, hasUpdatedTime?: boolean | null, hotkeyPlaybackRate?: number | null, isReady?: boolean | null, isSeeking?: boolean | null, isTranscriptionPanelOpen?: boolean | null, lastVolume?: number | null, customLoop?: boolean | null, mediaStartUTC?: number | null, muted?: boolean | null, paused?: boolean | null, playbackRateAudio?: number | null, playbackRateVideo?: number | null, overlayPlayButtonWasDismissed?: boolean | null, volume?: number | null, currentPage?: number | null, isPageDrawerOpen?: boolean | null, isPageDrawerAvailable?: boolean | null, isPanning?: boolean | null, isPdfLoaded?: boolean | null, shouldFallbackToImagePane?: boolean | null, pageCount?: number | null, currentUrl?: string | null, currentUrlPath?: string | null, liveUrlExternalUrl?: string | null, iframeWidth?: number | null, iframeHeight?: number | null, scrollX?: number | null, scrollY?: number | null, resolutionLastChangedBy?: string | null, resolutionType?: string | null, activeZoom?: Types.ZoomSetting | null, cachedFrameGuide?: string | null, fillZoomValue?: number | null, fitZoomValue?: number | null, focalPointX?: number | null, focalPointY?: number | null, frameGuide?: string | null, isDragging?: boolean | null, isFullscreen?: boolean | null, isMaskOn?: boolean | null, lastZoom?: number | null, viewHeight?: number | null, viewLeft?: number | null, viewTop?: number | null, viewWidth?: number | null, zoom?: number | null, rangeStart?: number | null, rangeDuration?: number | null, isRangeSelectorVisible?: boolean | null } | null> };


export const GetMediaState = /*#__PURE__*/ gql`
    query GetMediaState($mediaStateId: ID!) {
  getMediaState(mediaStateId: $mediaStateId) @client {
    ...MediaStateInfo
  }
}
    ${MediaStateInfo}` as unknown as DocumentNode<GetMediaStateQuery, GetMediaStateQueryVariables>;

          

          export const useGetMediaStateQuery = (options?:QueryHookOptions<GetMediaStateQuery, GetMediaStateQueryVariables>) => useQuery(GetMediaState, options);

          

          export type GetMediaStateQueryOptions = QueryHookOptions<GetMediaStateQuery, GetMediaStateQueryVariables>;

          

          export const useGetMediaStateLazyQuery = (options?:LazyQueryHookOptions<GetMediaStateQuery, GetMediaStateQueryVariables>) => useLazyQuery(GetMediaState, options);

          

          export type GetMediaStateQueryResult = ReturnType<typeof useGetMediaStateQuery>;

          
